import baseApi from "@/utils/baseApiUrl"

interface ComponentProps {
    chosenPdf: string | null
}

export default function PdfRenderComponent({ chosenPdf }: ComponentProps) {

    const API = baseApi()

    return (
        <section className="w-full">
            {chosenPdf ?
                <div className="w-full">
                    <iframe
                        src={`${API}/assets/${chosenPdf}`}
                        loading="lazy"
                        aria-label="Caressflow Bilimsel Çalışmalar"
                        className="w-full h-[70vh] md:h-screen"
                    ></iframe>
                </div>
                :
                <div className="w-full h-[50vh] md:h-screen flex items-center justify-center">
                    <p className="text-lg md:text-2xl text-gray-500">Okumak istediğiniz makaleyi seçebilirsiniz.</p>
                </div>
            }
        </section>
    )
}
